import { useEffect } from 'react';
import { useNavigate } from 'react-router-dom';
import { ShieldAlert, Trash2, ArrowRight } from 'lucide-react';
import { useApp } from '../context';
import { motion, AnimatePresence } from 'motion/react';

export function StorageFullModal() {
  const { state, dismissStorageWarning } = useApp();
  const navigate = useNavigate();

  // Only show if the storage is full
  if (!state.isStorageFull) return null;

  return (
    <AnimatePresence>
      <motion.div
        initial={{ opacity: 0 }}
        animate={{ opacity: 1 }}
        exit={{ opacity: 0 }}
        className="fixed inset-0 z-[100] flex items-center justify-center bg-slate-900/40 p-6 backdrop-blur-sm"
      >
        <motion.div
          initial={{ scale: 0.95, opacity: 0, y: 20 }}
          animate={{ scale: 1, opacity: 1, y: 0 }}
          exit={{ scale: 0.95, opacity: 0, y: 20 }}
          className="w-full max-w-sm rounded-[32px] bg-white p-6 shadow-2xl"
        >
          <div className="mx-auto mb-6 flex h-16 w-16 items-center justify-center rounded-full bg-red-50 text-red-500">
            <ShieldAlert size={32} />
          </div>

          <h2 className="mb-2 text-center text-xl font-bold text-slate-900">
            You're quite popular!
          </h2>
          <p className="mb-8 text-center text-[15px] leading-relaxed text-slate-500">
            You've made so many connections! We're out of local space on this device. Create a free
            account to sync your data to the cloud, or manage your existing contacts.
          </p>

          <div className="flex flex-col gap-3">
            <button
              onClick={() => {
                dismissStorageWarning();
                window.dispatchEvent(
                  new CustomEvent('open-login', { detail: { source: 'guest' } }),
                );
              }}
              className="flex w-full items-center justify-center gap-2 rounded-2xl bg-[#fa8585] p-4 font-bold text-white transition-all active:scale-[0.98]"
            >
              <span>Create Free Account</span>
              <ArrowRight size={18} />
            </button>
            <button
              onClick={() => {
                dismissStorageWarning();
                navigate('/contacts');
              }}
              className="flex w-full items-center justify-center gap-2 rounded-2xl bg-slate-100 p-4 font-bold text-slate-700 transition-all hover:bg-slate-200 active:scale-[0.98]"
            >
              <Trash2 size={18} />
              <span>Manage Data</span>
            </button>
          </div>
        </motion.div>
      </motion.div>
    </AnimatePresence>
  );
}
